import React, { FC } from 'react';
import { useTranslate } from '../../../../utils/hooks/useTranslate';

import styles from './styles.module.scss';

type CampaignNameConstructorPropTypes = {
    fullCampaignNameWithoutCustom: string;
    customCampaignName: string;
    setIsNameEditMode: (isEditMode: boolean) => void;
    asText?: boolean;
}

const CampaignNameConstructor: FC<CampaignNameConstructorPropTypes> = (props) => {
    const {
        fullCampaignNameWithoutCustom,
        customCampaignName,
        setIsNameEditMode,
        asText,
    } = props;
    const { t } = useTranslate();

    return (
        <p className={!asText ? styles.campaignNameOverlay : styles.asText}>
            <span id='full-campaign-name-without-custom'>
                {fullCampaignNameWithoutCustom.split('|').map((el, index) => {
                    const isLastElement = index === fullCampaignNameWithoutCustom.split('|').length - 1;
                    return (
                        <span key={index}>
                            <span>{el}</span>
                            {!isLastElement && (<span className={styles.separator}>|</span>)}
                        </span>
                    )
                })}
                <span className={styles.separator}> — </span>
                <span
                    data-exception='true'
                    className={!asText ? styles.customNameButton : ''}
                    onClick={() => !asText && setIsNameEditMode(true)}
                >
                    {customCampaignName || t`[Custom name]`}
                </span>
            </span>
        </p>
    );
};

export default CampaignNameConstructor;